import React, { useCallback, useEffect, useRef, useState } from "react";
import InventoryType from './Form/InventoryType';
import InventoryVehicleInfo from './Form/InventoryVehicleInfo';
//Import Breadcrumb
import { Box, Grid, LinearProgress, Stack } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Logo from '../../assets/images/Logo.svg';
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import CustomButton from "../../components/Form/CustomButton";
import { createInventory, getGeneral, getInventoryStockStatuses, requestSingpass, resetAdvertActionState, resetInventoryActionState, searchGeneral } from "../../store/actions";
import "../Advert/advert.css";
import VehicleList from "../Advert/Form/VehicleList";
import VerifyVehicle from "../Advert/Form/VerifyVehicle";
import SingpassLoginModal from "../Advert/modal/SingpassLogin";
// import PlateNoDetectionHelper from "../../helpers/plate_no_detection_helper";
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import moment from "moment";
import AppDialog from "../../components/Common/AppDialog";
import VehicleDetailsSummaryModal from "../Advert/modal/VehicleDetailsSummary";
import InventoryPricingInfo from "./Form/InventoryPricingInfo";
import InventoryReview from "./Form/InventoryReview";

const normalizeEngineCap = (value) => {
    if (typeof value !== 'string') {
        return value;
    }

    return value.replace(/\s*cc\s*$/i, '').trim();
};

const toNumberOrNull = value => value === "" || value === null || value === undefined
    ? null
    : Number(value);


const AddInventory = ({ leftSideBarType, layoutWidth, inventoryAdd, inventoryError, inventoryStockStatuses, userData, isDirectSeller, makeList, modelList, bodyList, erpDetails, singpassRes, transmissionList, generalCommonCode, erpListingInd, error }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState(1);
    const [formObj, setFormObj] = useState({ vehicle: { mileage: "", no_of_owner: "", engine_cap: "" }, pricing: { max_loan_tenure: 0, loan_amount: 0, monthly_instalment: "", term_charge: 0, }, contact_agreement: false, is_manually_fill: false });
    const [vehicleDetailsOpen, setVehicleDetailsOpen] = useState(false);
    const [singpassLoginOpen, setSingpassLoginOpen] = useState(false);
    const [loading, setIsLoading] = useState(false);
    const [draft, setDraft] = useState(false);
    const [singPassFillUpManually, setSingPassFillUpManually] = useState(false);
    const [preSelectBodyType, setPreSelectBodyType] = useState([]);
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const [defaultMyinfo, setDefaultMyinfo] = useState({ make: "", model: "" });
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const pendingInventoryRequest = useRef(null);
    const isSingPass = formObj?.inventory_type === "used" && formObj?.is_manually_fill !== true ? true : false;
    const totalPage = formObj?.inventory_type === "used" ? 6 : 4;

    const steps = formObj?.inventory_type === 'used'
        ? [
            { header: 'Next, choose your inventory type.', buttonText: '' },
            { header: 'Verify vehicle info & ownership', buttonText: '' },
            { header: 'Select vehicle', buttonText: 'Vehicle Info' },
            { header: 'Tell us more about the motorcycle.', buttonText: 'Vehicle Info' },
            { header: 'Set your pricing', buttonText: 'Pricing Details' },
            { header: 'Review and confirm', buttonText: 'Preview & Save' },
        ]
        : [
            { header: 'Next, choose your inventory type.', buttonText: '' },
            { header: 'Tell us more about the motorcycle.', buttonText: 'Vehicle Info' },
            { header: 'Set your pricing', buttonText: 'Pricing Details' },
            { header: 'Review and confirm', buttonText: 'Preview & Save' },
        ];

    useEffect(() => {
        if (isDirectSeller)
            navigate("/not-found")
    }, [])

    useEffect(() => {
        //for singpass show error message (data expired etc.)
        if (erpListingInd?.code === "error" && erpListingInd?.message !== "No vehicle details found in MyInfo. Please enter your vehicle details manually.") {
            // setIsLoading(false);
            setNotification({ open: true, type: 'error', msg: erpListingInd?.message || "Something went wrong, please try again later" });
            setSingPassFillUpManually(false)
        } else if (erpListingInd?.code === "error" && erpListingInd?.message === "No vehicle details found in MyInfo. Please enter your vehicle details manually.") {
            setSingPassFillUpManually(true)
            setNotification({ open: true, type: 'error', msg: erpListingInd?.message || "Something went wrong, please try again later" });

        }
    }, [erpListingInd]);

    useEffect(() => {
        dispatch(getGeneral());
        dispatch(searchGeneral({ type: "bike_makes", search: "" }));
        dispatch(getInventoryStockStatuses());
    }, [])

    useEffect(() => {
        // Singpass redirects back here with a token; resume directly at vehicle selection
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('token')) {
            handleFormObjChange('inventory_type', 'used');
            setCurrentStep(3);
        }
    }, []);

    useEffect(() => {
        if (singpassRes?.code === 'success') {
            setIsLoading(false);
            window.location.href = singpassRes?.data;
            dispatch(resetAdvertActionState());
        } else if (singpassRes?.code === 'network_error' || singpassRes?.code === 'invalid_field' || singpassRes?.code === 'error' || singpassRes?.code === 'unknown' || singpassRes?.code === 'unauthorized' || singpassRes?.code === 'forbidden' || singpassRes?.code === 'not_found' || singpassRes?.code === "unknown_error") {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: singpassRes?.message || singpassRes?.error_message || singpassRes?.data?.error_message || 'Failed to redirect to Singpass. Please try again.',
                type: 'error',
            });
            // dispatch(resetAdvertActionState());
        } else if (singpassRes?.code && singpassRes?.code !== "success") {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: singpassRes?.message || singpassRes?.error_message || singpassRes?.data?.error_message || "Failed",
                type: 'error',
            });
        }
    }, [singpassRes]);

    useEffect(() => {
        if (isSingPass && currentStep === 4) {
            const searchParams = new URLSearchParams(window.location.search);
            if (searchParams.has('token')) {
                searchParams.delete('token');
                const nextSearch = searchParams.toString();
                navigate(`${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}`, { replace: true });
            }
        }
    }, [currentStep, isSingPass, navigate])

    useEffect(() => {//set state when erp is selected from the list
        if (erpDetails?.data) {
            if (formObj?.open_selected_vehicle === true) {
                setVehicleDetailsOpen(true);
                handleFormObjChange('open_selected_vehicle', false);
            } else if ((erpDetails?.data?.id) === formObj?.selected_vehicle_id) {
                const regDateRaw = erpDetails.data?.reg_date || erpDetails.data?.first_reg_date;
                const coeDateRaw = erpDetails.data?.coe_expiry;
                // const regDate = regDateRaw ? moment(regDateRaw, "YYYY-MM-DD").format('YYYY-MM-DD') : null;
                // const coeDate = coeDateRaw ? moment(coeDateRaw, "DD MMM YYYY").format('YYYY-MM-DD') : null;
                setFormObj(prev => ({
                    ...prev,
                    vehicle: {
                        ...prev?.vehicle,
                        ...erpDetails.data,
                        transmission: erpDetails.data?.transmission,
                        engine_cap: normalizeEngineCap(erpDetails.data?.engine_cap),
                        reg_date: regDateRaw,
                        coe_expiry: coeDateRaw,
                        mileage: erpDetails?.erp_data?.mileage ?? 0,
                        no_of_owner: erpDetails?.erp_data?.no_of_owner ?? 0,
                    }
                }));
            } else if (formObj?.is_manually_fill !== true && !erpDetails?.data?.id) {//for singpass
                const selectedData = erpListingInd?.data?.data?.find((item, idx) => idx === formObj?.selected_vehicle_id);
                // dispatch(setErpDetailsLocal({ data: selectedData }));
                const regDateRaw = selectedData?.reg_date || selectedData?.first_reg_date;
                const coeDateRaw = selectedData?.coe_expiry || selectedData?.first_coe_expiry;
                setDefaultMyinfo({
                    make: selectedData?.make,
                    model: selectedData?.model
                });

                setFormObj(prev => ({
                    ...prev,
                    vehicle: {
                        ...prev?.vehicle,
                        ...selectedData,
                        transmission: selectedData?.transmission,
                        engine_cap: normalizeEngineCap(selectedData?.engine_cap),
                        reg_date: regDateRaw || null,
                        coe_expiry: coeDateRaw || null,
                        mileage: selectedData?.mileage ?? 0,
                        no_of_owner: selectedData?.no_of_owner ?? 0,
                        owner_name: selectedData?.name || null,
                    }
                }));
            }
            setIsLoading(false);
        }
    }, [erpDetails])


    useEffect(() => {
        //for singpass show error message (data expired etc.)
        if (erpListingInd?.code === "error") {
            // setIsLoading(false);
            setNotification({ open: true, type: 'error', msg: erpListingInd?.message || "Something went wrong, please try again later" });
        }
    }, [erpListingInd]);

    useEffect(() => {
        if (inventoryAdd?.code === 'success' || inventoryAdd?.code === 'validate_success') {
            const request = pendingInventoryRequest.current;
            setIsLoading(false);
            dispatch(resetInventoryActionState());

            if (request?.isFinal) {
                pendingInventoryRequest.current = null;
                navigate('/inventory')
            } else if (request?.nextStep) {
                pendingInventoryRequest.current = null;
                setCurrentStep(request.nextStep);
            }
        } else if (inventoryAdd?.code) {
            pendingInventoryRequest.current = null;
            setIsLoading(false);
            setNotification({
                open: true,
                msg: inventoryAdd?.message || 'Some fields are invalid. Please check again.',
                type: 'error',
            });
        }
    }, [inventoryAdd])

    useEffect(() => {
        if (!inventoryError || (Array.isArray(inventoryError) && inventoryError.length === 0)) return;
        pendingInventoryRequest.current = null;
        setIsLoading(false);
        setNotification({
            open: true,
            msg: inventoryError?.message || inventoryError?.[0] || 'Unable to save inventory. Please try again.',
            type: 'error',
        });
    }, [inventoryError]);

    const handleFormObjChange = (key, value) => {
        setFormObj((prev) => ({
            ...prev,
            [key]: value,
        }));
    }

    const removeTokenFromUrl = useCallback(() => {
        const searchParams = new URLSearchParams(window.location.search);
        if (!searchParams.has('token')) return;

        searchParams.delete('token');
        const nextSearch = searchParams.toString();
        navigate(`${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}`, { replace: true });
    }, [navigate]);

    const handleVehicleObjChange = (key, value) => {
        setFormObj(prev => {
            let tempObj = { ...prev.vehicle };
            tempObj[key] = value;
            if (key === 'bike_make_id') {
                tempObj['bike_model_id'] = null;
                tempObj['model'] = '';
                tempObj['model_name'] = '';
                tempObj['body_type'] = [];
                tempObj['bike_model_colour_id'] = null;
                tempObj['colour_text'] = null;
                tempObj['make'] = makeList?.find((make) => make.id === value)?.name || '';
            }
            if (key === 'bike_model_id') {
                tempObj['body_type'] = [];
                tempObj['bike_model_colour_id'] = null;
                tempObj['colour_text'] = null;
                // tempObj['body_type'] = null;
                tempObj['model'] = modelList?.find((model) => model.id === value)?.name || '';
            }
            if (key === 'bike_model_colour_id') {
                tempObj['bike_model_colour_id'] = value;
            }
            return { ...prev, vehicle: tempObj };
        });
    }

    const handlePricingObjChange = (key, value) => {
        setFormObj(prev => ({ ...prev, pricing: { ...prev.pricing, [key]: value } }));
    }

    const handleGoBack = () => {
        if (formObj?.inventory_type === 'used' && formObj?.is_manually_fill === true && currentStep === 4) {
            setCurrentStep(2);
            return;
        }
        if (isSingPass && currentStep === 4) {
            setCurrentStep(2);
            return;
        }
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        } else {
            navigate('/inventory');
        }
    }
    const handleRedirectSingpass = () => {
        setIsLoading(true);
        dispatch(requestSingpass({ bike_advert_plan_id: formObj?.bike_advert_plan_id }));
    }

    const getVehiclePayload = () => {
        const payload = {
            inventory_type: formObj?.inventory_type ?? null,
            bike_make_id: toNumberOrNull(formObj?.vehicle?.bike_make_id || formObj?.vehicle?.make_id),
            bike_model_id: toNumberOrNull(formObj?.vehicle?.bike_model_id || formObj?.vehicle?.model_id),
            register_number: formObj?.vehicle?.reg_no || formObj?.vehicle?.register_number || null,
            revision: 0,
            stock_status: toNumberOrNull(formObj?.vehicle?.stock_status),
            manu_year: toNumberOrNull(formObj?.vehicle?.manu_year),
            license_category_id: toNumberOrNull(formObj?.vehicle?.license_category_id),
            body_types: Array.isArray(formObj?.vehicle?.body_type)
                ? formObj.vehicle.body_type.map(type => Number(type))
                : [],
            bike_model_colour_id: toNumberOrNull(formObj?.vehicle?.bike_model_colour_id),
            colour_text: formObj?.vehicle?.colour_text || null,
            engine_cc: toNumberOrNull(formObj?.vehicle?.engine_cap),
            registration_date: formObj?.vehicle?.reg_date ? moment(formObj.vehicle.reg_date).format('YYYY-MM-DD') : null,
            coe_expiry: formObj?.vehicle?.coe_expiry ? moment(formObj.vehicle.coe_expiry).format('YYYY-MM-DD') : null,
            mileage_in_km: toNumberOrNull(formObj?.vehicle?.mileage),
            no_of_previous_owners: toNumberOrNull(formObj?.vehicle?.no_of_owner),
            owner_name: formObj?.vehicle?.owner_name || formObj?.owner_name,
            owner_email: formObj?.vehicle?.email || null,
            owner_phone: formObj?.vehicle?.phone
                ? (String(formObj.vehicle.phone).startsWith('+') ? formObj.vehicle.phone : `+65${formObj.vehicle.phone}`)
                : null,
            internal_remarks: formObj?.vehicle?.internal_remarks || null,
        };

        if (isSingPass) {
            payload.myinfo_make = defaultMyinfo?.make;
            payload.myinfo_model = defaultMyinfo?.model;
            payload.register_number = formObj?.vehicle?.reg_no;
        }

        return payload;
    };

    const getPricingPayload = () => formObj?.inventory_type === 'rental'
        ? {
            daily_rate: formObj?.pricing?.daily_rate ?? null,
            weekend_rate: formObj?.pricing?.weekend_rate ?? null,
            '3_days_rate': formObj?.pricing?.three_day_rate ?? null,
            weekly_rate: formObj?.pricing?.weekly_rate ?? null,
            monthly_rate: formObj?.pricing?.monthly_rate ?? null,
        }
        : {
            purchase_price: formObj?.pricing?.purchase_price ?? null,
            suggested_price: formObj?.pricing?.suggested_price ?? null,
            arf: formObj?.pricing?.arf ?? null,
        };

    const handleVerifyForm = () => {
        if (formObj?.inventory_type === 'used' && currentStep === 3 && formObj?.selected_vehicle_id == null) {
            setNotification({ open: true, msg: 'Please select a vehicle before proceeding.', type: 'error' });
            return;
        }

        let payload;
        let nextStep;
        const isFinal = currentStep === totalPage;

        if (isFinal) {
            payload = {
                step: 'submit',
                ...getVehiclePayload(),
                ...getPricingPayload(),
                ...(formObj?.inventory_type === 'used' && {
                    require_singpass: formObj?.is_manually_fill === true ? 0 : 1,
                    // singpass_id: formObj?.is_manually_fill === true ? null : (formObj?.singpass_id || formObj?.selected_vehicle_id || null),
                }),
                disclaimed: 1,
            };
        } else if (currentStep === 1) {
            payload = { step: 1, inventory_type: formObj?.inventory_type ?? null };
            nextStep = 2;
        } else if (formObj?.inventory_type === 'used' && currentStep === 3) {
            payload = formObj?.is_manually_fill === true
                ? {
                    step: 2,
                    inventory_type: 'used',
                    require_singpass: 0,
                    bike_make_id: formObj?.vehicle?.bike_make_id || formObj?.vehicle?.make_id,
                    bike_model_id: formObj?.vehicle?.bike_model_id || formObj?.vehicle?.model_id,
                }
                : {
                    step: 3,
                    inventory_type: 'used',
                    require_singpass: 1,
                    singpass_id: formObj?.singpass_id || formObj?.selected_vehicle_id || null,
                };
            nextStep = 4;
        } else if ((formObj?.inventory_type === 'used' && currentStep === 4) || currentStep === 2) {
            payload = { step: 4, ...getVehiclePayload() };
            nextStep = formObj?.inventory_type === 'used' ? 5 : 3;
        } else {
            payload = { step: 5, inventory_type: formObj?.inventory_type ?? null, ...getPricingPayload() };
            nextStep = formObj?.inventory_type === 'used' ? 6 : 4;
        }

        pendingInventoryRequest.current = { isFinal, nextStep };
        setIsLoading(true);
        dispatch(createInventory(payload));
    }

    const handleLoginSingpass = () => {
        // call singpass login api
        //if success get the vehicle list
        // and go to next step
        // setCurrentStep(currentStep + 1);
        setSingpassLoginOpen(false);
    }

    return (
        <React.Fragment>
            {
                layoutWidth > 768 &&
                <div style={{ position: 'fixed', zIndex: 9, width: '100%', backgroundColor: 'white', paddingBottom: 10 }}>
                    <div className="d-flex mb-2" style={{ backgroundColor: '#A70000', height: 10, width: `${(currentStep / totalPage * 100)}%`, transition: 'width 0.5s ease' }}></div>
                    <img src={Logo} alt="Logo" style={{ height: 21, width: 91, objectFit: 'contain' }} />
                </div>
            }
            <div className="page-content" style={{ marginTop: layoutWidth <= 768 && leftSideBarType === 'condensed' ? 72 : 0 }}>
                <LoadingDialog open={loading || generalCommonCode?.code !== "success"}
                // message={showSubmitLoadingMessage && currentStep === 8 ? (photoState >= 100 ? "Processing completed, submitting data...please wait" : <div style={{ textAlign: "center" }}>{photoState}% <br />Processing photo please wait...</div>) : undefined}

                />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} errors={error} />
                    <Box pt={layoutWidth <= 768 ? 2 : 6} pb={6} px={layoutWidth <= 768 ? 2 : 8}>
                        {
                            layoutWidth <= 768 &&
                            <div style={{ width: '100%', color: '#D13536', backgroundColor: '#F5F5F5', marginBottom: 20 }}>
                                <LinearProgress value={currentStep / totalPage * 100} variant="determinate" color="inherit" style={{ height: 9, borderRadius: 100 }} />
                            </div>
                        }
                        <Grid container spacing={2}>
                            <Grid item sm={currentStep === 3 && (isSingPass && singPassFillUpManually) ? 6 : 12} xs={12} >
                                <div className="subheader-2">Step {currentStep} of {totalPage}</div>
                                <Box className="d-flex justify-content-between" sx={{ flexDirection: { xs: "column", sm: "row" } }} >
                                    <div className="header-2">{steps[currentStep - 1]?.header}</div>
                                </Box>
                            </Grid>
                            {
                                currentStep === 3 && (isSingPass && singPassFillUpManually) &&
                                <Grid item xs={12} sm={6} justifyContent="flex-end" alignItems="flex-end" display="flex">
                                    <CustomButton
                                        title={'FILL UP MANUALLY'}
                                        press={() => {
                                            removeTokenFromUrl();
                                            handleFormObjChange('is_manually_fill', true);
                                            setCurrentStep(4);
                                        }}
                                        padding={20}
                                        backgroundColor={'transparent'}
                                        textColor={'#B48A3C'}
                                        fontSize={{ xs: 12, sm: 14 }}
                                        borderStyle={'1px solid transparent'}
                                    />
                                </Grid>
                            }
                            <Grid item md={12} sm={12} xs={12}>
                                {currentStep === 1 && <InventoryType handleVehicleObjChange={handleVehicleObjChange} isSingPass={isSingPass} formObj={formObj} handleFormChange={handleFormObjChange} error={error} />}
                                {(formObj?.inventory_type === "used" ? currentStep === 2 : false) && <VerifyVehicle isInventory={true} isSingPass={isSingPass} formObj={formObj} handleFormChange={handleFormObjChange} error={error} />}
                                {(formObj?.inventory_type === "used" ? currentStep === 3 && formObj?.is_manually_fill !== true : false) && <VehicleList isSingPass={isSingPass} isDirectSeller={isSingPass} formObj={formObj} handleFormChange={handleFormObjChange} handleVehicleObjChange={handleVehicleObjChange} windowWidth={layoutWidth} error={error} setIsLoading={setIsLoading} transmissionList={transmissionList} />}
                                {(formObj?.inventory_type === "used" ? currentStep === 4 : currentStep === 2) && <InventoryVehicleInfo isSingPass={isSingPass} inventoryStockStatuses={inventoryStockStatuses} defaultMyinfo={defaultMyinfo} invType={formObj?.inventory_type} is_manually_fill={formObj?.is_manually_fill} formObj={formObj?.vehicle} handleFormChange={handleVehicleObjChange} error={error} transmissionList={transmissionList} preSelectBodyType={preSelectBodyType} setPreSelectBodyType={setPreSelectBodyType} />}
                                {(formObj?.inventory_type === "used" ? currentStep === 5 : currentStep === 3) && <InventoryPricingInfo isSingPass={isSingPass} formObj={formObj?.pricing} handleFormChange={handlePricingObjChange} vehicle={formObj?.vehicle} windowWidth={layoutWidth} error={error} setNotification={setNotification} invType={formObj?.inventory_type} />}
                                {(formObj?.inventory_type === "used" ? currentStep === 6 : currentStep === 4) && <InventoryReview inventoryStockStatuses={inventoryStockStatuses} isSingPass={isSingPass} formObj={formObj} />}
                            </Grid>
                        </Grid>
                    </Box>

                </Container>
            </div>
            {
                currentStep <= totalPage && <div className="mobile-button-container d-flex justify-content-between">
                    <CustomButton
                        title={'Go Back'}
                        press={() => handleGoBack()}
                        borderStyle={'1px solid #1D1B1B'}
                        backgroundColor={'white'}
                        textColor={'#1D1B1B'}
                        padding={20}
                    />
                    {
                        currentStep === totalPage ?
                            <Stack direction="row" columnGap={1}>
                                <CustomButton
                                    title={'Save Inventory'}
                                    backgroundColor={'#1D1B1B'}
                                    press={() => { handleVerifyForm(); setDraft(false); }}
                                    padding={20}
                                />
                            </Stack>
                            :
                            formObj?.inventory_type === "used" && currentStep === 2 ?
                                <Stack direction="row" columnGap={1}>
                                    <CustomButton
                                        title={'FILL UP MANUALLY'}
                                        press={() => { handleFormObjChange('is_manually_fill', true); setCurrentStep(4) }}
                                        padding={20}
                                        backgroundColor={'transparent'}
                                        textColor={'#B48A3C'}
                                        fontSize={{ xs: 12, sm: 14 }}
                                        borderStyle={'1px solid transparent'}
                                    />
                                    <CustomButton
                                        title={'Retrieve Myinfo with Singpass'}
                                        press={() => handleRedirectSingpass()}
                                        backgroundColor={'#F4333D'}
                                        textColor={'white'}
                                        borderStyle={'none'}
                                        padding={10}
                                        fontSize={{ xs: 12, sm: 14 }}
                                        borderRadius={'5px'}
                                    />
                                </Stack>
                                : <CustomButton
                                    title={`${layoutWidth <= 768 ? 'Next' : `Next: ${currentStep === 1 ? (formObj?.inventory_type === "used" ? "Verify Vehicle Info & Ownership" : `Vehicle Info`) : steps[currentStep]?.buttonText}`}`}
                                    press={() => {
                                        handleVerifyForm();
                                    }
                                    }
                                    backgroundColor={'#1D1B1B'}
                                    padding={20}
                                />
                    }

                </div>
            }
            <AppDialog
                open={errorModalOpen}
                close={() => setErrorModalOpen(false)}
                customTitle={
                    <Stack direction="row" columnGap={1} alignItems="center">
                        <CustomButton
                            title={'Go back & Edit'}
                            press={() => { setErrorModalOpen(false) }}
                            padding={10}
                            backgroundColor={'white'}
                            textColor={'black'}
                            fontSize={{ xs: 12, sm: 14 }}
                            borderStyle={'1px solid black'}
                        />
                        <CustomButton
                            title={'Proceed to Submit'}
                            fontSize={{ xs: 12, sm: 14 }}
                            press={() => { setErrorModalOpen(false); handleVerifyForm(false, true) }}
                            padding={10}
                            backgroundColor={'#d32f2f'}
                            textColor={'white'}
                            borderStyle={'1px solid #d32f2f'}
                        />
                    </Stack>
                } width={'50%'}
            >
                <Grid container spacing={2}>
                    <Grid item xs={2}>
                        <ReportGmailerrorredIcon style={{ color: "#d32f2f" }} />
                    </Grid>
                    <Grid item xs={10}>
                        One or more of the uploaded images may contain visible plates number. Please ensure all images are properly masked before submitting.
                    </Grid>
                </Grid>
            </AppDialog>

            <SingpassLoginModal
                open={singpassLoginOpen}
                close={() => setSingpassLoginOpen(false)}
                handleLoginSingpass={() => handleLoginSingpass()}
            />
            <VehicleDetailsSummaryModal
                open={vehicleDetailsOpen}
                advertType={formObj?.inventory_type}
                close={() => setVehicleDetailsOpen(false)}
                selectedVehicle={erpDetails.data}
                windowWidth={layoutWidth}
                bodyList={bodyList}
            />
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Layout, Advert, Inventory, General }) {
    return {
        userData: Login?.verifyAdmin?.user?.data,
        isDirectSeller: Login?.verifyAdmin?.user?.data?.profile?.selected_dealer_id ? false : true,
        userPermission: Login?.permissionArry,
        leftSideBarType: Layout.leftSideBarType,
        layoutWidth: Layout.currentWidth,
        inventoryAdd: Inventory.inventoryAdd,
        inventoryError: Inventory.error,
        inventoryStockStatuses: Inventory.inventoryStockStatuses?.library || [],
        advertRequestMakeModel: Advert.advertRequestMakeModel,
        planList: General.bike_advert_plans,
        makeList: General.bike_makes,
        modelList: General.bike_models,
        bodyList: General.bike_types,
        transmissionList: General.transmissions,
        license_categories: General.license_categories,
        erpDetails: Advert.erpDetails || null,
        erpListingInd: Advert.erpListing || null,
        singpassRes: Advert.singpassRes || null,
        generalCommonCode: General?.generalCommonCode || null,
        error: Inventory?.error?.errors || Inventory?.inventoryAdd?.errors || null,
    };
}


export default connect(mapStateToProps)(AddInventory);
